import React from "react";

import { Header } from "./Header";
import { Button } from "./Header/Button";
import { StickyPaper } from "./StickyPaper";
import { IStickyHeaderProps } from "./types";

const StickyHeader: React.FC<IStickyHeaderProps> = ({ headerProps, isMobile, relativeSticky }) => (
  <>
    <StickyPaper relativeSticky={relativeSticky}>
      <Header showCtaButton={!isMobile} {...headerProps!} />
    </StickyPaper>
    {isMobile && <Button isSticky={true} {...headerProps!.ctaProps} />}
  </>
);

export { StickyHeader };
